import { LOCATION_CHANGE } from 'connected-react-router';

import { trackTwttr } from 'app/analytics/trackers/twttr';
import { trackAdWords } from 'app/analytics/trackers/adWords';
import { tradeDeskUP as trackTradeDeskUP } from 'app/analytics/trackers/tradeDeskUP';
import { fbq as trackFbqPageView } from 'app/analytics/trackers/fbq';
import { isUserAuthenticated } from 'app/features/user/selectors';
import { routeNameFromPath } from 'app/router/selectors';

const trackExternalPageChanged = (action, getState) => {
  if (action.type === LOCATION_CHANGE) {
    const isAuthenticated = isUserAuthenticated(getState());
    const { authorizedRoutes } = window.etp.config;
    const route = routeNameFromPath(getState());

    if (!isAuthenticated && authorizedRoutes.includes(route)) {
      return;
    }

    trackTwttr();
    trackAdWords();
    trackTradeDeskUP();
    trackFbqPageView('PageView');
  }
};

export default trackExternalPageChanged;
